<div class="side-nav-ext">
  <div class="side-nav-ext-container">
    <div class="menu-icon-wrapper">
      <i (click)="menuClicked.emit(null)" class="material-icons">{{menuIcon}}</i>
    </div>
  </div>
</div>
